import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { RemitAdjustment, RemitAdjustmentPayload } from '@/types/billing';
import PaginatedResponse from '@/types/paginatedResponse';
import RepositoryResponse from '@/types/repositoryResponse';

import { createRepository } from './GenericRepository';

const basePath = '/api/billing/remit_adjustments';

export const remitAdjustmentRepository = createRepository<RemitAdjustment, RemitAdjustmentPayload>(
  basePath
);

const RemitAdjustmentRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(
      params: Record<string, string> = {}
    ): Promise<RepositoryResponse<PaginatedResponse<RemitAdjustment[]>>> {
      return remitAdjustmentRepository.list({ host, params });
    },

    async get({ id }: { id: string }): Promise<RepositoryResponse<RemitAdjustment>> {
      return remitAdjustmentRepository.get({ host, id });
    },
    async create({ data }: { data: RemitAdjustmentPayload }): Promise<RemitAdjustment> {
      return remitAdjustmentRepository.create({ host, data });
    },
    async update({
      id,
      data
    }: {
      id: string;
      data: RemitAdjustmentPayload;
    }): Promise<RemitAdjustment> {
      return remitAdjustmentRepository.update({ host, id: id, data });
    },
    async delete({ id }: { id: string }) {
      return await remitAdjustmentRepository.delete({ host, id });
    }
  };
};

export default RemitAdjustmentRepository;
